import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-184221f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background-gradient" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "align-right" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Accept ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Decline ")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "You have no pending requests", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 💩 ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackSwipe = _resolveComponent("BackSwipe")!
  const _component_Header = _resolveComponent("Header")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_FriendCell = _resolveComponent("FriendCell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BackSwipe),
    _createVNode(_component_Header, { title: "Friend requests" }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.pendingFriendRequests.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingFriendRequests, (request) => {
                  return (_openBlock(), _createBlock(_component_FriendCell, {
                    key: request.requester.userId,
                    friend: request.requester,
                    shouldDisplayUsername: true
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_van_button, {
                          id: "left-button",
                          round: "",
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (_ctx.acceptFriendRequest(request.requester.userId))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_van_button, {
                          round: "",
                          onClick: ($event: any) => (_ctx.declineFriendRequest(request.requester.userId)),
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["friend"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
    ])
  ]))
}